import calendar from './files/icons/calendar.svg';
import check from './files/icons/check.svg';
import checkWhite from './files/icons/check_white.svg';
import chevronDown from './files/icons/chevron-down.svg';
import deleteAsset from './files/icons/delete.svg';
import edit from './files/icons/edit.svg';
import geography from './files/icons/geography.svg';
import magnifierSearchBar from './files/icons/magnifier-searchBar.svg';
import pantoneRank from './files/icons/pantone_rank.svg';
import save from './files/icons/save.svg';
import saveActive from './files/icons/save_active.svg';
import saveGhost from './files/icons/save_ghost.svg';
import saveHover from './files/icons/save_hover.svg';
import search from './files/icons/search.svg';
import send from './files/icons/send.svg';
import x from './files/icons/x.svg';

export default {
  calendar,
  check,
  checkWhite,
  chevronDown,
  delete: deleteAsset,
  edit,
  geography,
  magnifierSearchBar,
  pantoneRank,
  save,
  saveActive,
  saveGhost,
  saveHover,
  search,
  send,
  x,
};
